import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppBrowserModule } from './app/app.browser.module';
import { environment } from './app/environments/environments';

if (environment.production) {
  enableProdMode();
}

// Suppress the strokeDashoffset animation warning from Angular Material
const originalWarn = console.warn;
console.warn = function(...args: any[]) {
  const message = args[0]?.toString() || '';
  if (message.includes('strokeDashoffset') && message.includes('animationState')) {
    // Suppress this specific warning
    return;
  }
  originalWarn.apply(console, args);
};

platformBrowserDynamic().bootstrapModule(AppBrowserModule)
  .catch(err => console.error(err));
